define(
    'viewmodels/secured/explorer/details/tabs/actions/PurgeDeletedAction',[
        "viewmodels/secured/explorer/context",
        "viewmodels/secured/explorer/details/tabs/actions/Action",
        "viewmodels/secured/explorer/details/documentClipboard",
        "services/config",
        "services/eventbroker",
        "services/service.dialog",
        "services/service.documents",
        "i19n!i19n/strings"
    ],
    function (ctx, Action, documentClipboard, config, eventBroker, dialogService, documentsService, i19n) {

        var PurgeDeletedAction = (function (_super) {

            var _i19n = {
                action: {
                    name: i19n.to.purgedeleted,
                    message: i19n.to.permanentlydeletedocuments + ".",
                }
            };

            __extends(Action, _super);

            function _Action(context, disableFilters, hideFilters) {
                _super.call(this, _i19n.action, "fa-times", context, disableFilters, hideFilters);

                this.command = Action.getCommand(this, { execute: execute });
            }

            function execute(action, complete) {
                documentsService.actions.canPurgeDeleted(action.context.checkedDocuments())
                    .done(function (result) {
                        var promise;

                        if (!result.success) {
                            promise = dialogService.showDocumentActionErrorDialog(result);
                        } else {
                            var folderId = action.context.checkedDocuments()[0].folderId;
                            var libraryId = action.context.checkedDocuments()[0].libraryId;

                            promise = dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionPurgeModal", '');
                        
                            promise.then(function (dialogResult) {
                                if (dialogResult.purging) {
                                    documentsService.actions.purgedeletedDocuments(documentClipboard.toDocumentIdList(action.context.checkedDocuments()))
                                    .done(function () {
                                    })
                                    .fail(function (e) {
                                        e.stopPropagation = true;
                                        self.errors(e.error);
                                    })
                                    .always(function () {
                                        ctx.onReloadResults(null);
                                        ctx.onDocument(null);

                                        complete();
                                    });
                                } else {
                                    complete();
                                }
                            });
                        }

                        promise.then(complete);
                    });
              }

            return _Action;

        })(Action);

        return PurgeDeletedAction;
        
    });
